import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IsActiveMatchOptions, RouterLink, RouterLinkActive } from '@angular/router';
import { Tooltip } from 'primeng/tooltip';

import { injectSidebarContext } from '../sidebar-context';

const descendantRouteMatch: IsActiveMatchOptions = {
    paths: 'subset',
    queryParams: 'ignored',
    matrixParams: 'ignored',
    fragment: 'ignored',
};

@Component({
    selector: 'adv-sidebar-body-item',
    templateUrl: './sidebar-body-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, RouterLink, RouterLinkActive, Tooltip],
})
export class SidebarBodyItemComponent {
    readonly route = input.required<(string | number)[]>();
    readonly label = input.required<string>();
    readonly tooltip = input<string>();
    readonly shortcut = input<string>();
    readonly disabled = input(false);
    readonly testId = input<string>();

    private readonly _sidebar = injectSidebarContext();

    protected readonly iconOnly = this._sidebar.iconOnly;
    protected readonly routeMatchOptions = descendantRouteMatch;
    protected readonly tooltipText = computed(() => {
        const tooltip = this.tooltip();
        const shortcut = this.shortcut();

        if (!tooltip) {
            return this.label();
        }

        return shortcut ? `${this.label()} (${shortcut}): ${tooltip}` : `${this.label()}: ${tooltip}`;
    });

    protected preventDisabledNavigation(event: MouseEvent): void {
        if (this.disabled()) {
            event.preventDefault();
        }
    }
}
